import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncProductAndSubdomainSelect } from './function';

export const AsyncProductAndSubdomainSelectFormField = FormFieldBlueprint.make({
  name: 'async-product-and-subdomain-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncProductAndSubdomainSelect',
        component: AsyncProductAndSubdomainSelect,
      }),
  },
});
